import clsx from "clsx";
import { JournalVersionStatus } from "../../model/types";
import "./version-status-tag.scss";

interface VersionStatusTagProps {
  status: JournalVersionStatus;
  versionNumber?: number;
  variant?: "table" | "card";
}

const STATUS_CONFIG: Record<
  JournalVersionStatus,
  { label: string; icon: string; className: string }
> = {
  ACTUAL: {
    label: "В работе",
    icon: "⊙",
    className: "version-status-tag--actual",
  },
  OUTDATED: {
    label: "Неактуально",
    icon: "⊘",
    className: "version-status-tag--outdated",
  },
};

export const VersionStatusTag = ({
  status,
  versionNumber,
  variant = "card",
}: VersionStatusTagProps) => {
  const config = STATUS_CONFIG[status];

  if (variant === "table" && versionNumber !== undefined) {
    return (
      <span className={clsx("version-status-tag", "version-status-tag--table", config.className)}>
        <span className="version-status-tag__icon">{config.icon}</span>
        <span className="version-status-tag__number">{versionNumber}</span>
      </span>
    );
  }

  return (
    <span className={clsx("version-status-tag", "version-status-tag--card", config.className)}>
      <span className="version-status-tag__icon">{config.icon}</span>
      <span className="version-status-tag__label">{config.label}</span>
    </span>
  );
};
